import type {
    GetActivityForModal_activity as ActivityForModal,
    GetActivityForModal_activity_logNote_audioLog as AudioLog,
} from 'nutshell-graphql-types';

export function checkHasRecordings(activity: ActivityForModal): boolean {
    const hasAudio = Boolean(activity.shouldDisplayAudio && getAudioLog(activity));
    const hasVideo = activity.shouldDisplayVideo;

    return hasAudio || hasVideo;
}

export function getAudioLog(activity: ActivityForModal): AudioLog | null | undefined {
    const logNoteAudio = activity.logNote && activity.logNote.audioLog;
    const externalMeetingAudio = activity.externalMeeting && activity.externalMeeting.audioLog;

    return logNoteAudio || externalMeetingAudio;
}
